import { createReducer } from '@reduxjs/toolkit'
import {
  activateTool,
  setPermitFile,
  setSelectedPage,
  updatePermitPage,
} from '../actions/permit'
import { CommentWithReplies } from '../models/Comment'
import { DrawingFile } from '../models/File'
import { toolsGroup1 } from '../components/Permit/Tools'

interface PermitState {
  file: DrawingFile | null
  comments: CommentWithReplies[]
  selectedPageId: string
  activeTool: string
}

const initialState: PermitState = {
  file: null,
  comments: [],
  selectedPageId: '',
  activeTool: toolsGroup1.tools[0].name,
}

const permitReducer = createReducer(initialState, (builder) => {
  builder.addCase(setPermitFile, (state, action) => {
    state.file = action.payload.permitFile
  })
  builder.addCase(updatePermitPage, (state, action) => {
    if (!state.file) {
      return
    }

    const pageIndex = state.file.pages.findIndex(
      (page) => page.id === action.payload.page.id,
    )
    if (pageIndex !== -1) {
      state.file.pages[pageIndex] = {
        ...state.file.pages[pageIndex],
        ...action.payload.page,
      }
    }
  })
  builder.addCase(setSelectedPage, (state, action) => {
    state.selectedPageId = action.payload.pageId
  })
  builder.addCase(activateTool, (state, action) => {
    state.activeTool = action.payload
  })
})

export default permitReducer
